function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("rect", {
  x: 2.916,
  y: 9.476,
  width: 50.084,
  height: 10.866,
  rx: 2,
  ry: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.626 3.826H44.29a2.17 2.17 0 012.178 2.173v3.477l-37.02-.082V5.999a2.17 2.17 0 012.178-2.173zM50.278 20.539L48.1 51.094c-.085 1.2-.97 2.173-2.177 2.173H9.993c-1.207 0-2.093-.972-2.178-2.173L5.638 20.373z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeWidth: 0.919
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.0888 0 0 1.0866 -2.528 -2.477)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28 24v22"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.921
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 42,
  r: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.921
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.54439 -.94104 .94292 .54331 -20.287 42.888)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28 24v22"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.921
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 42,
  r: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.921
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-.54439 -.94104 -.94292 .54331 76.203 42.888)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28 24v22"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.921
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 42,
  r: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.921
})));

var SvgCooler = function SvgCooler(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCooler, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cooler.de1eb015.svg";
export { ForwardRef as ReactComponent };